const Regex = {
  user_id: /^[a-zA-Z0-9]+$/,
  password:
    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()\-+=^])[A-Za-z\d!@#$%&*()\-+=^]{8,30}$/,
  user_id_filter: /[^a-zA-Z0-9]/g,
  password_filter: /\s/g,
  register_user_id: /[^a-zA-Z0-9]/g,
  password_mismatch: /\s/g,
  nameValidation: /^[A-Za-z\s]*$/,
  mobile_number: /(0|91)?[6-9][0-9]{9}/,
  alpha_numeric_special: /^[\w\s!@#$%^&*()_+{}[\]:;"'<>,.?/~`\\|-]*$/,
  pincode_filter: /^[1-9]{1}[0-9]{2}\s{0,1}[0-9]{3}$/,
  commaRegex: /,/g,
  numericRegex: /[^0-9,]/g,
  numberRegex: /[^0-9]/g,
  numericRegexandspace: /^\d+$/,
  numericWithDecimalRegex: /^\d{0,48}(\.\d{0,2})?$/,
  thousandSeparatorRegex: /\B(?=(\d{3})+(?!\d))/g,
  characterRegex: /[^A-Za-z\s]/g,
  commaSeperatedNumberRegex: /\B(?=(\d{3})+(?!\d))/g,
};

export default Regex;
